import type { FC, ReactElement, ReactNode } from 'react';

import type { IconProps } from '../Icons/BaseIcon';
import Text from '../Text';
import * as Styled from './Callout.styled';
import { CalloutIcon } from './components/CalloutIcon';

export enum CalloutType {
  INFO = 'info',
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
  NEUTRAL = 'neutral',
}

export type CalloutOverrides = {
  Icon: FC<IconProps>;
  iconColor: string;
  background: string;
  borderStyle: string;
  color: string;
};

export interface CalloutProps {
  headline?: string;
  type?: CalloutType;
  overrides?: Partial<CalloutOverrides>;
  customIcon?: ReactElement;
  action?: ReactNode;
  hideIcon?: boolean;
  className?: string;
  withBorder?: boolean;
  rounded?: boolean;
  hasCloseButton?: boolean;
  iconOnTop?: boolean;
  onCloseClick?: () => void;
  dark?: boolean;
  children?: ReactNode;
}

import { useTheme } from 'styled-components';

// ...

const Callout = ({
  headline,
  children,
  type,
  overrides,
  customIcon,
  action,
  hideIcon,
  className,
  rounded,
  withBorder = true,
  hasCloseButton,
  iconOnTop,
  dark: propDark,
  onCloseClick,
}: CalloutProps) => {
  const theme = useTheme() as any;
  const dark = propDark ?? theme?.activeColorScheme?.type === 'dark';

  return (
    <Styled.CalloutWrapper
      $dark={dark}
      $iconOnTop={iconOnTop}
      $overrides={overrides}
      $rounded={rounded}
      $type={type}
      $withBorder={withBorder}
      className={className}
    >
      {!hideIcon &&
        (customIcon ? (
          customIcon
        ) : (
          <CalloutIcon dark={dark} overrides={overrides} type={type} />
        ))}
      <Styled.CalloutContentWrapper>
        <Styled.CalloutContent>
          {headline && (
            <Styled.CalloutHeadline as="p">{headline}</Styled.CalloutHeadline>
          )}
          <Text className="w-full">{children}</Text>
        </Styled.CalloutContent>
        {action && <Styled.CalloutAction>{action}</Styled.CalloutAction>}
        {hasCloseButton && <Styled.CloseButton onClick={onCloseClick} />}
      </Styled.CalloutContentWrapper>
    </Styled.CalloutWrapper>
  );
};

export type { BorderStylesProps } from './Callout.styled';
export { BorderStyles, CalloutWrapper } from './Callout.styled';
export { CalloutIcon };

export default Callout;
